// extracted by mini-css-extract-plugin
export default {"wrapper":"Announcements_wrapper__ILiLA","mainWrapper":"Announcements_mainWrapper__kCyuP","loading":"Announcements_loading__0+bxY"};